export default {
  mounted() {
    this.listDict();
  },
  methods: {
    // 获取字典值
    listDict() {
      return this.$_post(this.$API.selectDict, {
        data: {
          dictTypeCode: 'prdType',
        },
      }).then((res) => {
        this.dictList = res.data.list;
      });
    },
  },
};
